import { reportsApi } from 'Api/axios/reports-api';
import { useEffect, useState } from 'react';
import { CourseReportFilterI, CourseReportI } from 'types';
import type { ReportsPaginationI } from 'Pages/reports/components/ReportsDataGrid/types';

interface Props {
  init?: boolean;
}

const useCoursesReportApi = ({ init = false }: Props) => {
  const [data, setData] = useState<CourseReportI[]>([]);
  const [pagination, setPagination] = useState<ReportsPaginationI | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCoursesReport = async (filters: CourseReportFilterI) => {
    setLoading(true);
    const response = await reportsApi.readCourses(filters);
    setLoading(false);
    setData(response.data ?? []);
    setPagination(response.pagination ?? null);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchCoursesReport({ page: 1, pageSize: 15 });
    }
  }, [init]);

  return { data, pagination, loading, error, fetchCoursesReport };
};

export default useCoursesReportApi;
